import ApplicationFormIcons from '@/resources/customIcons/ApplicationFormIcons';
import React from 'react';
import { CreditCard, FileText } from 'lucide-react';
import { translate } from '@/services/TranslationService';
import { NovovilleButton } from '@/components/novoville';
import VerifyModal from '../modal/VerifyModal';

export const shownModules = [
  'reports',
  'discussions',
  'form_applications',
  'bills',
];

export const shownModulesEnabledFn = (modules) => {
  const modulesNamesArray = modules.map((module) => module.name);
  return shownModules.filter((module) => modulesNamesArray.includes(module));
};

export const MODULE_CTA_METADATA = ({
  goTo,
  setIsModalOpen,
  isModalOpen,
  handleVerificationModalSkip,
}) => ({
  reports: {
    basicColor: 'strongCyan',
    title: translate('Reports'),
    subTitle: translate("Let's take proactive steps"),
    icon: <FileText className="w-[24px] h-[24px]" />,
    cardAction: (
      <VerifyModal
        onClick={() => handleVerificationModalSkip('newReport')}
        onOpenChange={(isOpen) =>
          isOpen ? setIsModalOpen('reports') : setIsModalOpen(null)
        }
        shouldOpen={isModalOpen && isModalOpen === 'reports'}
        buttonClass={
          'w-fit min-w-[170px] bg-strongCyan active:bg-cyan hover:bg-strongCyan hover:text-white'
        }
      >
        {translate('newReportLower')}
      </VerifyModal>
    ),
  },
  discussions: {
    basicColor: 'lightPurple',
    title: translate('HOME.consultationBanner'),
    subTitle: translate('HOME.consultationDescription'),
    icon: <FileText className="w-[24px] h-[24px]" />,
    cardAction: (
      <NovovilleButton
        onClick={() => goTo('discussions')}
        className="w-fit min-w-[170px] bg-lightPurple active:bg-lightPurple hover:bg-purpleLink hover:text-white"
        variant="primary"
      >
        {translate('HOME.consultationAction')}
      </NovovilleButton>
    ),
  },
  form_applications: {
    basicColor: 'darkOrange',
    title: translate('HOME.applicationBanner'),
    subTitle: translate('HOME.applicationDescription'),
    icon: <ApplicationFormIcons className={'w-[24] h-[24]'} />,
    cardAction: (
      <NovovilleButton
        onClick={() => goTo('applications')}
        className="w-fit min-w-[170px] bg-darkOrange active:bg-orange hover:bg-darkOrange hover:text-white"
        variant="primary"
      >
        {translate('HOME.applicationAction')}
      </NovovilleButton>
    ),
  },
  bills: {
    basicColor: 'lightBlue',
    title: translate('sideMenu.Payments'),
    subTitle: translate('HOME.billsDescription'),
    icon: <CreditCard className={'w-[24] h-[24]'} />,
    cardAction: (
      <VerifyModal
        onClick={() => handleVerificationModalSkip('payments')}
        onOpenChange={(isOpen) =>
          isOpen ? setIsModalOpen('payments') : setIsModalOpen(null)
        }
        shouldOpen={isModalOpen && isModalOpen === 'payments'}
        buttonClass="w-fit min-w-[170px] bg-lightBlue active:bg-blue hover:bg-lightBlue hover:text-white"
      >
        {translate('NewPayment')}
      </VerifyModal>
    ),
  },
});
